export const DeviceVendorWithModelEnum = {
    CALYX_Y: 'CALYX_Y',
    NETVOX_R718H: 'NETVOX_R718H',
    AGROMEANS_SMART_SCALE: 'AGROMEANS_SMART_SCALE',
}